<app-header></app-header>

<div class="responsive">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-3">
        <app-sidebar></app-sidebar>
      </div>

      <div class="col-md-9">
        <div class="container py-4">

          <div class="d-flex justify-content-between align-items-center mb-4">
            <h4 class="mb-0">{{ isEditMode ? 'Edit Job Posting' : 'Create New Job' }}</h4>
            <button class="btn btn-outline-secondary" routerLink="/jobs">
              ← Back to Jobs
            </button>
          </div>

          <form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>

            <!-- Job Post Information -->
            <div class="card mb-4 shadow-sm">
              <div class="card-header bg-primary text-white fw-bold">
                Job Post Information
              </div>
              <div class="card-body">

                <div class="row g-3">
                  <div class="col-md-6">
                    <label class="form-label fw-bold">Company Name <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" formControlName="companyName"
                           [class.is-invalid]="submitted && f.companyName.invalid">
                    <div class="invalid-feedback" *ngIf="submitted && f.companyName.errors?.required">
                      Company name is required
                    </div>
                  </div>
                  <div class="col-md-6">
                    <label class="form-label fw-bold">Your Name <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" formControlName="name"
                           [class.is-invalid]="submitted && f.name.invalid">
                    <div class="invalid-feedback" *ngIf="submitted && f.name.errors?.required">
                      Your name is required
                    </div>
                  </div>
                </div>

                <div class="row g-3 mt-3">
                  <div class="col-md-6">
                    <label class="form-label fw-bold">Email <span class="text-danger">*</span></label>
                    <input type="email" class="form-control" formControlName="email"
                           [class.is-invalid]="submitted && f.email.invalid">
                    <div class="invalid-feedback" *ngIf="submitted">
                      <span *ngIf="f.email.errors?.required">Email is required</span>
                      <span *ngIf="f.email.errors?.email">Invalid email format</span>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <label class="form-label fw-bold">Role <span class="text-danger">*</span></label>
                    <select class="form-select" formControlName="role"
                            [class.is-invalid]="submitted && f.role.invalid">
                      <option *ngFor="let r of roleOptions" [value]="r">{{r}}</option>
                    </select>
                    <div class="invalid-feedback" *ngIf="submitted && f.role.errors?.required">
                      Please select a role
                    </div>
                  </div>
                </div>

                <div class="row g-3 mt-3">
                  <div class="col-md-6">
                    <label class="form-label">Phone Number</label>
                    <input type="tel" class="form-control" formControlName="phoneNumber">
                  </div>
                  <div class="col-md-6">
                    <label class="form-label">Company Website</label>
                    <input type="url" class="form-control" formControlName="companyWebsite"
                           placeholder="https://www.example.com">
                  </div>
                </div>

                <div class="mt-3">
                  <label class="form-label fw-bold">Company Values / About Us</label>
                  <textarea class="form-control" rows="3" formControlName="companyValues" maxlength="500"
                            placeholder="Tell candidates about your company culture, mission, values..."></textarea>
                  <small class="text-muted d-block mt-1">
                    {{ form.get('companyValues')?.value?.length || 0 }}/500
                  </small>
                </div>

                <div class="mt-4">
                  <h6>Privacy Settings</h6>
                  <div class="row g-2">
                    <div class="col-6 col-md-3">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" formControlName="hideName" id="hideName">
                        <label class="form-check-label" for="hideName">Hide Name</label>
                      </div>
                    </div>
                    <div class="col-6 col-md-3">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" formControlName="hideEmail" id="hideEmail">
                        <label class="form-check-label" for="hideEmail">Hide Email</label>
                      </div>
                    </div>
                    <div class="col-6 col-md-3">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" formControlName="hidePhone" id="hidePhone">
                        <label class="form-check-label" for="hidePhone">Hide Phone</label>
                      </div>
                    </div>
                    <div class="col-6 col-md-3">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" formControlName="hideWebsite" id="hideWebsite">
                        <label class="form-check-label" for="hideWebsite">Hide Website</label>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>

            <!-- Job Basics -->
            <div class="card mb-4 shadow-sm">
              <div class="card-header bg-primary text-white fw-bold">Job Basics</div>
              <div class="card-body">

                <div class="row g-3">
                  <div class="col-md-6">
                    <label class="form-label fw-bold">Industry <span class="text-danger">*</span></label>
                    <select class="form-select" formControlName="industry"
                            [class.is-invalid]="submitted && f.industry.invalid">
                      <option *ngFor="let i of industryOptions" [value]="i">{{i}}</option>
                    </select>
                    <div class="invalid-feedback" *ngIf="submitted && f.industry.errors?.required">
                      Industry is required
                    </div>
                  </div>
                  <div class="col-md-6">
                    <label class="form-label fw-bold">Job Title <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" formControlName="jobTitle" maxlength="120"
                           [class.is-invalid]="submitted && f.jobTitle.invalid"
                           placeholder="e.g. Senior React Developer">
                    <div class="invalid-feedback" *ngIf="submitted && f.jobTitle.errors?.required">
                      Job title is required
                    </div>
                    <small class="text-muted d-block mt-1">
                      {{ form.get('jobTitle')?.value?.length || 0 }}/120
                    </small>
                  </div>
                </div>

                <div class="row g-3 mt-3">
                  <div class="col-md-6">
                    <label class="form-label">Category / Department</label>
                    <input type="text" class="form-control" formControlName="category"
                           placeholder="e.g. Software Engineering, Marketing">
                  </div>
                  <div class="col-md-6">
                    <label class="form-label">Remote Job</label>
                    <select class="form-select" formControlName="remoteJob">
                      <option *ngFor="let r of remoteJobOptions" [value]="r">{{r}}</option>
                    </select>
                  </div>
                </div>

                <div class="mt-3" formGroupName="jobLocation">
                  <label class="form-label fw-bold">Job Location</label>
                  <input type="text" class="form-control" ngx-google-places-autocomplete
                         (onAddressChange)="onJobLocationChange($event)" formControlName="googleAddress"
                         placeholder="Type city, address or landmark...">

                  <div class="form-check mt-3">
                    <input class="form-check-input" type="checkbox" formControlName="showAddress" id="showAddr">
                    <label class="form-check-label" for="showAddr">Show full address publicly</label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" formControlName="showContactInfo" id="showContact">
                    <label class="form-check-label" for="showContact">Show contact info publicly</label>
                  </div>
                </div>

              </div>
            </div>

            <!-- Job Details -->
            <div class="card mb-4 shadow-sm">
              <div class="card-header bg-primary text-white fw-bold">Job Details</div>
              <div class="card-body">

                <div class="row g-3">
                  <div class="col-md-6">
                    <label class="form-label">Job Type</label>
                    <select class="form-select" formControlName="jobType">
                      <option *ngFor="let t of jobTypeOptions" [value]="t">{{t}}</option>
                    </select>
                  </div>
                  <div class="col-md-6">
                    <label class="form-label">Job Pay / Compensation</label>
                    <input type="text" class="form-control" formControlName="jobPay"
                           placeholder="e.g. ₹12–18 LPA, $90k–$130k / year, ₹800–₹1,200 / hr">
                  </div>
                </div>

                <div class="mt-3">
                  <label class="form-label fw-bold">Job Duties & Responsibilities</label>
                  <textarea class="form-control" rows="6" formControlName="jobDuties" maxlength="2000"
                            placeholder="Describe key responsibilities, daily tasks, expected outcomes..."></textarea>
                  <small class="text-muted d-block mt-1">
                    {{ form.get('jobDuties')?.value?.length || 0 }}/2000
                  </small>
                </div>

                <div class="mt-3">
                  <label class="form-label fw-bold">Required Skills & Qualifications</label>
                  <textarea class="form-control" rows="4" formControlName="requiredSkills" maxlength="1000"
                            placeholder="e.g. • React & TypeScript (3+ years)&#10;• Node.js / Express&#10;• AWS or Azure experience&#10;• Excellent communication"></textarea>
                  <small class="text-muted d-block mt-1">
                    {{ form.get('requiredSkills')?.value?.length || 0 }}/1000
                  </small>
                </div>

              </div>
            </div>

            <!-- Recruiting Address -->
            <div class="card mb-4 shadow-sm">
              <div class="card-header bg-primary text-white fw-bold">Recruiting Address</div>
              <div class="card-body" formGroupName="recruiting">

                <div class="row g-3">
                  <div class="col-md-8">
                    <label class="form-label">Address Line</label>
                    <input type="text" class="form-control" formControlName="address"
                           placeholder="Office / Campus / Building address">
                  </div>
                  <div class="col-md-4">
                    <label class="form-label">City</label>
                    <input type="text" class="form-control" formControlName="city">
                  </div>
                </div>

                <div class="row g-3 mt-3">
                  <div class="col-md-4">
                    <label class="form-label">State / Province</label>
                    <input type="text" class="form-control" formControlName="state">
                  </div>
                  <div class="col-md-4">
                    <label class="form-label">Postal Code</label>
                    <input type="text" class="form-control" formControlName="postalCode">
                  </div>
                  <div class="col-md-4">
                    <label class="form-label">Country</label>
                    <input type="text" class="form-control" formControlName="country">
                  </div>
                </div>

                <div class="row g-3 mt-3">
                  <div class="col-md-6">
                    <label class="form-label">Contact Number (Recruiter/HR)</label>
                    <input type="tel" class="form-control" formControlName="contactNumber">
                  </div>
                </div>

                <div class="mt-4">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" formControlName="limitToCurrentRegion" id="limitRegion">
                    <label class="form-check-label" for="limitRegion">Only accept applicants from this region</label>
                  </div>
                  <div class="form-check mt-2">
                    <input class="form-check-input" type="checkbox" formControlName="showAddress" id="showRecAddr">
                    <label class="form-check-label" for="showRecAddr">Show address publicly</label>
                  </div>
                  <div class="form-check mt-2">
                    <input class="form-check-input" type="checkbox" formControlName="showContact" id="showRecContact">
                    <label class="form-check-label" for="showRecContact">Show contact number publicly</label>
                  </div>
                </div>

              </div>
            </div>

            <!-- Application Settings -->
            <div class="card mb-4 shadow-sm">
              <div class="card-header bg-primary text-white fw-bold">
                Application Instructions
              </div>
              <div class="card-body">

                <div class="row g-3">
                  <div class="col-md-6">
                    <label class="form-label fw-bold">How to Apply <span class="text-danger">*</span></label>
                    <select class="form-select" formControlName="howReceiveApplications"
                            [class.is-invalid]="submitted && f.howReceiveApplications.invalid">
                      <option *ngFor="let opt of applicationReceiveOptions" [value]="opt">{{opt}}</option>
                    </select>
                    <div class="invalid-feedback" *ngIf="submitted && f.howReceiveApplications.errors?.required">
                      Please select application method
                    </div>
                  </div>
                  <div class="col-md-6">
                    <label class="form-label fw-bold">Application Link / Email / Phone <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" formControlName="contactInformation"
                         
                           [class.is-invalid]="submitted && f.contactInformation.invalid">
                    <div class="invalid-feedback" *ngIf="submitted && f.contactInformation.errors?.required">
                      Application contact is required
                    </div>
                  </div>
                </div>

                <div class="row g-3 mt-3">
                  <div class="col-md-6">
                    <label class="form-label">Required Documents</label>
                    <input type="text" class="form-control" formControlName="requiredDocuments"
                           placeholder="e.g. Resume, Cover Letter, Portfolio, ID Proof">
                  </div>
                  <div class="col-md-6">
                    <label class="form-label">Duration (days)</label>
                    <input type="number" class="form-control" formControlName="durationDays" min="1" max="365"
                           placeholder="Default: 30 days">
                  </div>
                </div>

              </div>
            </div>

            <!-- Submit Buttons -->
            <div class="text-center mt-5 d-flex justify-content-center gap-4">
              <button type="button" class="btn btn-outline-secondary btn-lg px-5"
                      (click)="cancel()" [disabled]="isLoading">
                Cancel
              </button>

              <button type="submit" class="btn btn-success btn-lg px-5"
                      [disabled]="form.invalid || submitted || isLoading">
                <span *ngIf="!isLoading">{{ isEditMode ? 'Update Job' : 'Create Job' }}</span>
                <span *ngIf="isLoading">
                  <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Saving...
                </span>
              </button>
            </div>

          </form>
        </div>
      </div>
    </div>
  </div>
</div>